// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container_Wutm4{flex:1 1 auto;width:100%;font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.tabsBar_38UrP{position:relative;display:flex;flex:0 1 auto;border-radius:inherit;height:48px;max-width:100%;color:#272525}.sliderWrapper_8nD_g,.tabsBar_38UrP{transition:.3s cubic-bezier(.25,.8,.5,1)}.sliderWrapper_8nD_g{position:absolute;bottom:0;margin:0!important;z-index:1}.slider_2ZXKw{height:100%;width:100%;background-color:currentColor}", ""]);
// Exports
exports.locals = {
	"container": "container_Wutm4",
	"tabsBar": "tabsBar_38UrP",
	"sliderWrapper": "sliderWrapper_8nD_g",
	"slider": "slider_2ZXKw"
};
module.exports = exports;
